/* Riva theme behavior: header, gallery, testimonials, buy box, drawers, AJAX cart.
   Source of truth for interactions: design/design_reference/website prototypes. */
(function () {
  'use strict';

  var moneyFormat = (window.rivaSettings && window.rivaSettings.moneyFormat) || '${{amount}}';

  /* Every placeholder Shopify uses in a currency's money format (SEK is
     "{{amount_with_space_separator}} kr", CHF uses the apostrophe one). */
  function formatMoney(cents) {
    function delimit(decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var formats = {
      amount: delimit(2, ',', '.'),
      amount_no_decimals: delimit(0, ',', '.'),
      amount_with_comma_separator: delimit(2, '.', ','),
      amount_no_decimals_with_comma_separator: delimit(0, '.', ','),
      amount_with_space_separator: delimit(2, ' ', ','),
      amount_no_decimals_with_space_separator: delimit(0, ' ', ','),
      amount_with_apostrophe_separator: delimit(2, "'", '.'),
      amount_no_decimals_with_apostrophe_separator: delimit(0, "'", '.'),
      amount_with_period_and_space_separator: delimit(2, ' ', '.')
    };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
      return formats.hasOwnProperty(key) ? formats[key] : match;
    });
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------- Header ---------------- */
  function initHeader() {
    var stack = document.querySelector('.rv-header-stack');
    if (!stack) return;
    if (document.querySelector('.rv-hero')) stack.classList.add('is-over-hero');
    var onScroll = function () {
      stack.classList.toggle('is-scrolled', window.scrollY > 320);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    var burger = stack.querySelector('.rv-hamburger');
    var scrim = stack.querySelector('[data-rv-menu-scrim]');
    var panel = stack.querySelector('.rv-mobile-menu');
    var setMenu = function (open) {
      stack.classList.toggle('is-menu-open', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    if (burger && panel) {
      burger.addEventListener('click', function () {
        setMenu(!stack.classList.contains('is-menu-open'));
      });
      if (scrim) scrim.addEventListener('click', function () { setMenu(false); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && stack.classList.contains('is-menu-open')) setMenu(false);
      });
      panel.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-rv-submenu-toggle]');
        if (!toggle) return;
        var item = toggle.closest('.rv-mobile-menu__item');
        var open = item.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      var desktopMq = window.matchMedia('(min-width: 1024px)');
      var onMqChange = function (e) { if (e.matches) setMenu(false); };
      if (desktopMq.addEventListener) desktopMq.addEventListener('change', onMqChange);
      else if (desktopMq.addListener) desktopMq.addListener(onMqChange);
    }
    stack.querySelectorAll('[data-rv-open-cart]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        setMenu(false);
        window.rivaCart.open();
      });
    });
  }

  /* ---------------- Sale window countdowns ---------------- */
  /* A deadline ships as epoch seconds plus the window length in days, so the
     browser never parses a date string and never guesses the shop's UTC offset.
     The old code assumed +02:00 while the shop is Europe/Vilnius, which runs
     +03:00 through the summer, so every deadline fired an hour late.

     Shopify can serve a full-page-cached render from minutes ago, so a cached
     page can arrive carrying a boundary that has just passed. Rolling forward by
     whole windows keeps the timer running instead of expiring the copy on a
     visitor who did nothing wrong. */
  function rvWindowEnd(el) {
    var secs = parseInt(el.getAttribute('data-rv-end'), 10);
    if (!secs) return null;
    var end = secs * 1000;
    if (end > Date.now()) return end;

    /* Boundary already gone, so this render came out of the page cache. A
       following boundary shipped alongside it heals the gap exactly, which
       matters for the dispatch cutoff because the next one is not simply a day
       later across a weekend. Otherwise step by whole windows. */
    var next = parseInt(el.getAttribute('data-rv-end-next'), 10);
    if (next && next * 1000 > Date.now()) return next * 1000;

    var days = parseInt(el.getAttribute('data-rv-cadence'), 10) || 0;
    if (days > 0) {
      var step = days * 86400000;
      var guard = 0;
      while (end <= Date.now() && guard < 520) { end += step; guard += 1; }
    }
    return end;
  }

  function rvClock(ms) {
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400);
    return (d > 0 ? d + 'd ' : '') +
      pad(Math.floor(s % 86400 / 3600)) + ':' +
      pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
  }

  /* Live timer for one element carrying data-rv-end. onExpire fires only for a
     window with no cadence, which is a genuine one-off deadline. */
  function rvCountdown(el, onExpire) {
    var end = rvWindowEnd(el);
    if (!end) return;
    var out = el.querySelector('[data-rv-count]');
    var dayEl = el.querySelector('[data-rv-day]');
    var label = el.getAttribute('data-rv-count-label') || '';
    var shipped = parseInt(el.getAttribute('data-rv-end'), 10) * 1000;

    /* Once the resolved boundary is no longer the one the server rendered, the
       day the parcel leaves has moved with it. This runs at load, for a render
       that came out of the page cache, and again if the cutoff passes while
       somebody is sitting on the page; without it the clock would roll to
       tomorrow while the sentence still promised dispatch today. Returns false
       when the copy can no longer be corrected, and the caller then drops the
       line rather than leaving a claim it cannot stand behind. */
    var syncDay = function (resolved) {
      if (!dayEl || resolved === shipped) return true;
      var nextDay = el.getAttribute('data-rv-day-next');
      if (!nextDay) return false;
      dayEl.textContent = nextDay;
      el.removeAttribute('data-rv-day-next');
      return true;
    };

    if (!syncDay(end)) { if (onExpire) onExpire(); return; }

    var tick = function () {
      var ms = end - Date.now();
      if (ms <= 0) {
        var rolled = rvWindowEnd(el);
        if (rolled && rolled > end) {
          end = rolled;
          if (!syncDay(end) && onExpire) onExpire();
          return;
        }
        if (onExpire) onExpire();
        return;
      }
      if (!out) return;
      out.textContent = label ? label + ' ' + rvClock(ms) : rvClock(ms);
      out.hidden = false;
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------------- Announcement bar: rotation + sale countdown ---------------- */
  function initAnnouncement() {
    var bar = document.querySelector('.rv-announcement');
    if (!bar) return;
    var msgs = Array.prototype.slice.call(bar.querySelectorAll('[data-rv-ann-msg]'));
    var saleMsg = bar.querySelector('[data-rv-ann-sale]');

    var idx = 0;
    var show = function (i) {
      idx = i;
      msgs.forEach(function (m, j) { m.classList.toggle('is-active', j === idx); });
    };
    var dropSaleMsg = function () {
      if (!saleMsg) return;
      var wasActive = saleMsg.classList.contains('is-active');
      msgs = msgs.filter(function (m) { return m !== saleMsg; });
      saleMsg.remove();
      saleMsg = null;
      if (!msgs.length) { bar.remove(); return; }
      if (wasActive) show(0);
    };

    /* Scoped to the sale message, not the bar: the dispatch message carries its
       own timer and both would otherwise claim the same count element. */
    if (saleMsg) rvCountdown(saleMsg, dropSaleMsg);

    if (msgs.length > 1) {
      setInterval(function () {
        if (msgs.length > 1) show((idx + 1) % msgs.length);
      }, 4500);
    }
  }

  /* Dated urgency copy outside the announcement bar: runs the same live timer and
     rolls forward with the window, so it can never go stale. A deadline shipped
     without a cadence still removes itself rather than making a promise that has
     already expired. The sale message is excluded because initAnnouncement owns
     it and has to drop it from the rotator rather than just remove it. */
  function initDeadlines(root) {
    (root || document).querySelectorAll('[data-rv-end]:not([data-rv-ann-sale])').forEach(function (el) {
      rvCountdown(el, function () { el.remove(); });
    });
  }

  /* ---------------- Locale pickers + geo country ---------------- */
  var GEO_KEY = 'rv:geo-checked';
  function markGeoChecked() {
    try { localStorage.setItem(GEO_KEY, '1'); } catch (e) { /* noop */ }
  }
  function closeLocalePickers() {
    document.querySelectorAll('[data-rv-locale].is-open').forEach(function (picker) {
      picker.classList.remove('is-open');
      var btn = picker.querySelector('.rv-locale__btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }
  var localeListenersBound = false;
  function initLocalePickers(root) {
    var pickers = (root || document).querySelectorAll('[data-rv-locale]');
    if (!pickers.length) return;
    pickers.forEach(function (picker) {
      var btn = picker.querySelector('.rv-locale__btn');
      var panel = picker.querySelector('.rv-locale__panel');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = !picker.classList.contains('is-open');
        closeLocalePickers();
        if (!open) return;
        picker.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        panel.scrollTop = 0; /* always open at the top of the list */
        if (!picker.rvFlagsLoaded) {
          /* Fetch all row flags on first open so scrolling never stutters on lazy loads */
          picker.rvFlagsLoaded = true;
          panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        }
        if (picker.closest('.rv-mobile-menu')) panel.scrollIntoView({ block: 'nearest' });
      });
      picker.addEventListener('click', function (e) {
        var opt = e.target.closest('.rv-locale__opt');
        if (!opt) return;
        markGeoChecked(); /* a manual pick must never be overridden by geo detection */
        if (opt.classList.contains('is-current')) {
          e.preventDefault(); /* already active: no point in a reload */
          closeLocalePickers();
          return;
        }
        /* The switch is a full POST + reload; respond instantly while it runs:
           show the picked value on the trigger, close the list, spin + dim. */
        var optName = opt.querySelector('.rv-locale__name');
        var optCur = opt.querySelector('.rv-locale__cur');
        var optFlag = opt.querySelector('img.rv-locale__flag');
        var label = btn.querySelector('.rv-locale__label');
        var curEl = btn.querySelector('.rv-locale__cur');
        var flagEl = btn.querySelector('.rv-locale__flag');
        if (optFlag && flagEl) flagEl.style.backgroundImage = "url('" + optFlag.src + "')";
        if (curEl && optCur) curEl.textContent = optCur.textContent;
        if (label) {
          if (!curEl && optCur) label.textContent = optCur.textContent;
          else if (optName) label.textContent = optName.textContent;
        }
        closeLocalePickers();
        picker.classList.add('is-loading');
        document.documentElement.classList.add('rv-locale-switching');
      });
    });
    if (localeListenersBound) return;
    localeListenersBound = true;
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-rv-locale]')) closeLocalePickers();
    });
    /* Capture phase so Escape closes an open picker before the menu/cart handlers see it */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!document.querySelector('[data-rv-locale].is-open')) return;
      e.stopPropagation();
      closeLocalePickers();
    }, true);
  }
  /* First visit: switch to the visitor's market once, based on Shopify's
     IP-derived suggestion. Never re-runs (localStorage flag), never fights a
     manual pick or an existing localization cookie, skips editor and bots. */
  function initGeoCountry() {
    var stack = document.querySelector('.rv-header-stack[data-rv-geo]');
    if (!stack) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (navigator.webdriver || /bot|crawl|spider/i.test(navigator.userAgent)) return;
    var current = window.rivaSettings && window.rivaSettings.localization && window.rivaSettings.localization.country;
    if (!current) return;
    try { if (localStorage.getItem(GEO_KEY)) return; } catch (e) { return; }
    if (/(^|;\s*)localization=/.test(document.cookie)) { markGeoChecked(); return; }
    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        markGeoChecked();
        var country = data && data.detected_values && data.detected_values.country;
        var detected = country && country.handle;
        if (!detected || detected === current) return;
        var opt = document.querySelector('.rv-locale__form button[name="country_code"][value="' + detected + '"]');
        if (!opt) return; /* visitor's country is not an enabled market */
        var form = opt.closest('form');
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'country_code';
        input.value = detected;
        form.appendChild(input);
        form.submit();
      })
      .catch(function () { markGeoChecked(); });
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-rv-cart-count]').forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var cart = {
    root: null,
    init: function () {
      this.root = document.getElementById('RivaCartDrawer');
      if (!this.root) return;
      this.bind();
    },
    bind: function () {
      var self = this;
      var drawer = this.root.querySelector('.rv-drawer');
      if (!drawer) return;
      drawer.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-rv-cart-close]')) { self.close(); return; }
        var step = t.closest('[data-rv-line-qty]');
        if (step) {
          self.changeLine(step.getAttribute('data-key'), parseInt(step.getAttribute('data-rv-line-qty'), 10));
          return;
        }
        var remove = t.closest('[data-rv-line-remove]');
        if (remove) {
          self.changeLine(remove.getAttribute('data-key'), 0);
          return;
        }
        var upsell = t.closest('[data-rv-upsell-add]');
        if (upsell) {
          self.add([{ id: parseInt(upsell.getAttribute('data-rv-upsell-add'), 10), quantity: 1 }]);
          return;
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });
    },
    drawerEl: function () { return this.root ? this.root.querySelector('.rv-drawer') : null; },
    open: function () {
      var d = this.drawerEl();
      if (!d) return;
      d.classList.add('is-open');
      d.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      var d = this.drawerEl();
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    setLoading: function (on) {
      var d = this.drawerEl();
      if (d) d.classList.toggle('is-loading', on);
    },
    renderSection: function (html) {
      if (!html || !this.root) return;
      var wasOpen = this.drawerEl() && this.drawerEl().classList.contains('is-open');
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('#RivaCartDrawer');
      if (!fresh) return;
      this.root.innerHTML = fresh.innerHTML;
      this.bind();
      if (wasOpen) this.open();
      var d = this.drawerEl();
      if (d) setCartCount(parseInt(d.getAttribute('data-cart-count') || '0', 10));
    },
    refresh: function () {
      var self = this;
      return fetch(window.location.pathname + '?sections=riva-cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) { self.renderSection(data['riva-cart-drawer']); });
    },
    add: function (items) {
      var self = this;
      self.setLoading(true);
      return fetch(window.rivaSettings.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items, sections: 'riva-cart-drawer' }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (data) {
          if (data.sections) self.renderSection(data.sections['riva-cart-drawer']);
          self.open();
        })
        .catch(function (err) {
          console.error('[riva] cart add failed', err);
          alert((err && err.description) || 'Could not add to cart.');
        })
        .then(function () { self.setLoading(false); });
    },
    changeLine: function (key, quantity) {
      var self = this;
      if (!key) return;
      self.setLoading(true);
      return fetch(window.rivaSettings.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: 'riva-cart-drawer' }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections) self.renderSection(data.sections['riva-cart-drawer']);
        })
        .catch(function (err) { console.error('[riva] cart change failed', err); })
        .then(function () { self.setLoading(false); });
    },
  };
  window.rivaCart = cart;

  /* ---------------- Product gallery (infinite drag slider) ---------------- */
  function initGallery(gallery) {
    var track = gallery.querySelector('.rv-gallery__track');
    var slides = track.querySelectorAll('.rv-gallery__slide:not(.rv-gallery__clone)');
    var n = slides.length;
    if (n < 2) {
      gallery.querySelectorAll('.rv-capsule, .rv-gallery__dots, .rv-gallery__thumbs, .rv-gallery__arrow').forEach(function (el) { el.remove(); });
      return;
    }
    var sel = 0;
    var dragX = 0;
    var dragging = false;
    var noAnim = false;
    var counter = gallery.querySelector('[data-rv-gallery-count]');
    var dots = gallery.querySelectorAll('.rv-gallery__dot');
    var thumbs = gallery.querySelectorAll('.rv-gallery__thumb');
    var progress = gallery.querySelector('[data-rv-gallery-progress]');
    var thumbRail = gallery.querySelector('.rv-gallery__thumbs');

    function cur() { return ((sel % n) + n) % n; }
    function apply() {
      track.classList.toggle('no-anim', noAnim);
      track.style.transform = 'translateX(calc(-' + sel + ' * (var(--gpw) + var(--rv-gap)) + ' + dragX + 'px))';
      if (counter) counter.textContent = (cur() + 1) + ' / ' + n;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === cur()); });
      if (progress) progress.style.transform = 'translateX(' + (cur() * 100) + '%)';
      thumbs.forEach(function (t, i) {
        var on = i === cur();
        t.classList.toggle('is-active', on);
        /* Keep the active thumbnail inside the rail without scrolling the page */
        if (on && thumbRail && thumbRail.scrollHeight > thumbRail.clientHeight) {
          var top = t.offsetTop - thumbRail.offsetTop;
          if (top < thumbRail.scrollTop || top + t.offsetHeight > thumbRail.scrollTop + thumbRail.clientHeight) {
            thumbRail.scrollTo({ top: top - 8, behavior: 'smooth' });
          }
        }
      });
    }
    function next() { sel += 1; apply(); }
    function prev() {
      if (sel === 0) {
        noAnim = true; sel = n; apply();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { noAnim = false; sel = n - 1; apply(); });
        });
      } else { sel -= 1; apply(); }
    }
    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (sel >= n) {
        noAnim = true; sel -= n; apply();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { noAnim = false; apply(); });
        });
      }
    });

    var drag = null;
    gallery.addEventListener('pointerdown', function (e) { drag = { x: e.clientX, moved: false, id: e.pointerId }; });
    gallery.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 6) {
        drag.moved = true;
        dragging = true;
        gallery.classList.add('is-dragging');
        try { gallery.setPointerCapture(drag.id); } catch (err) { /* noop */ }
      }
      if (drag.moved) { dragX = dx; apply(); }
    });
    function endDrag() {
      if (drag && drag.moved) {
        if (dragX < -60) sel += 1;
        else if (dragX > 60) { dragX = 0; prev(); drag = null; dragging = false; gallery.classList.remove('is-dragging'); apply(); return; }
      }
      drag = null; dragX = 0; dragging = false;
      gallery.classList.remove('is-dragging');
      apply();
    }
    gallery.addEventListener('pointerup', endDrag);
    gallery.addEventListener('pointercancel', endDrag);
    gallery.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rv-gallery-prev],[data-rv-gallery-next],[data-rv-gallery-dot]');
      if (!b) return;
      e.preventDefault();
      if (b.hasAttribute('data-rv-gallery-prev')) prev();
      else if (b.hasAttribute('data-rv-gallery-next')) next();
      else { sel = parseInt(b.getAttribute('data-rv-gallery-dot'), 10); apply(); }
    });

    /* Video slides: poster-first, but eager — once the gallery is on screen
       every video loads and starts muted, even while it's only the peeking
       slide, so it's already mid-play when the visitor reaches it. Pauses
       off-screen or in a hidden tab; tap-to-play fallback for reduced-motion,
       Save-Data, or a rejected play() (iOS Low Power). */
    var videos = [];
    track.querySelectorAll('.rv-gallery__slide:not(.rv-gallery__clone)').forEach(function (slide, i) {
      var el = slide.querySelector('.rv-gallery__video');
      if (el) videos.push({ i: i, el: el, btn: slide.querySelector('.rv-video-play'), loaded: false, userStarted: false, blocked: false });
    });
    if (videos.length) {
      var autoplayOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
        !(navigator.connection && navigator.connection.saveData);
      var galleryOnScreen = function () {
        var r = gallery.getBoundingClientRect();
        return r.bottom > 0 && r.top < window.innerHeight;
      };
      var startVideo = function (v) {
        if (!v.loaded) { v.el.src = v.el.getAttribute('data-src'); v.loaded = true; }
        v.el.muted = true;
        var p = v.el.play();
        if (p && p.then) {
          p.then(function () {
            v.blocked = false;
            v.el.classList.add('is-playing');
            if (v.btn) v.btn.hidden = true;
          }).catch(function (err) {
            /* AbortError = our own pause() interrupted a pending play() */
            if (err && err.name === 'AbortError') return;
            v.blocked = true;
            if (v.btn && v.i === cur()) v.btn.hidden = false;
          });
        }
      };
      var syncVideos = function () {
        var onScreen = galleryOnScreen() && !document.hidden;
        videos.forEach(function (v) {
          if (onScreen && (autoplayOk || v.userStarted)) {
            /* Retry a blocked video only once its slide is current: the swipe
               that brought it there counts as the unlocking gesture on iOS. */
            if (!v.blocked || v.userStarted || v.i === cur()) {
              if (!v.loaded || v.el.paused) startVideo(v);
            }
          } else if (onScreen && v.i === cur()) {
            if (v.btn) v.btn.hidden = false;
          } else if (!onScreen && v.loaded && !v.el.paused) {
            v.el.pause();
          }
          if (v.btn && v.i !== cur()) v.btn.hidden = true;
        });
      };
      videos.forEach(function (v) {
        if (v.btn) {
          v.btn.addEventListener('click', function (e) {
            e.stopPropagation();
            v.userStarted = true;
            startVideo(v);
          });
        }
      });
      track.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'transform') syncVideos();
      });
      window.addEventListener('scroll', syncVideos, { passive: true });
      document.addEventListener('visibilitychange', syncVideos);
      var applyBase = apply;
      apply = function () { applyBase(); syncVideos(); };
      syncVideos();
    }

    /* ---- Zoom lightbox: tap an image slide (or the magnifier button) to open
       it fullscreen with pinch, double-tap, wheel zoom and drag-to-pan. The
       modal is re-parented to <body> so no ancestor transform/overflow can
       trap the fixed overlay. ---- */
    var zoomModal = document.querySelector('[data-rv-zoom-modal]');
    if (zoomModal) {
      if (zoomModal.parentElement !== document.body) document.body.appendChild(zoomModal);
      var zoomImg = zoomModal.querySelector('img');
      var zoomPrevBtn = zoomModal.querySelector('[data-rv-zoom-prev]');
      var zoomNextBtn = zoomModal.querySelector('[data-rv-zoom-next]');
      var zoomCapsule = zoomModal.querySelector('[data-rv-zoom-capsule]');
      var zoomCount = zoomModal.querySelector('[data-rv-zoom-count]');
      var zoomOpenBtn = gallery.querySelector('[data-rv-zoom-open]');
      var zoomList = [];
      var slideZoomIndex = [];
      slides.forEach(function (slide, i) {
        var zsrc = slide.getAttribute('data-rv-zoom');
        if (zsrc) {
          var zim = slide.querySelector('img');
          slideZoomIndex[i] = zoomList.length;
          zoomList.push({ src: zsrc, alt: (zim && zim.alt) || '' });
        } else { slideZoomIndex[i] = -1; }
      });
      if (!zoomList.length && zoomOpenBtn) zoomOpenBtn.hidden = true;
      if (zoomList.length) {
        var zi = 0, zs = 1, ztx = 0, zty = 0, zBaseW = 0, zBaseH = 0;
        var zPointers = [], zPinch = null, zPan = null, zMoved = false, zLastTap = null, zDownTarget = null;

        var zRender = function () {
          zoomImg.style.transform = 'translate(' + ztx + 'px, ' + zty + 'px) scale(' + zs + ')';
        };
        var zMeasure = function () {
          var r = zoomImg.getBoundingClientRect();
          zBaseW = r.width / zs; zBaseH = r.height / zs;
        };
        var zClamp = function () {
          if (zs <= 1.001) { zs = 1; ztx = 0; zty = 0; return; }
          var mx = Math.max(0, (zBaseW * zs - zoomModal.clientWidth) / 2);
          var my = Math.max(0, (zBaseH * zs - zoomModal.clientHeight) / 2);
          ztx = Math.min(mx, Math.max(-mx, ztx));
          zty = Math.min(my, Math.max(-my, zty));
        };
        var zZoomAt = function (clientX, clientY, newScale, animate) {
          var target = Math.min(4, Math.max(1, newScale));
          var k = target / zs;
          var qx = clientX - zoomModal.clientWidth / 2;
          var qy = clientY - zoomModal.clientHeight / 2;
          ztx = qx - k * (qx - ztx);
          zty = qy - k * (qy - zty);
          zs = target;
          zClamp();
          if (animate) {
            zoomImg.classList.add('rv-zoom-anim');
            setTimeout(function () { zoomImg.classList.remove('rv-zoom-anim'); }, 240);
          }
          zRender();
        };
        var zToggle = function (clientX, clientY) {
          if (zs > 1.01) zZoomAt(zoomModal.clientWidth / 2, zoomModal.clientHeight / 2, 1, true);
          else zZoomAt(clientX, clientY, 2.5, true);
        };
        var zSwitchTimer = null, zCloseTimer = null;
        var zShow = function (idx) {
          zi = ((idx % zoomList.length) + zoomList.length) % zoomList.length;
          zs = 1; ztx = 0; zty = 0;
          if (zoomCount) zoomCount.textContent = (zi + 1) + ' / ' + zoomList.length;
          var entry = zoomList[zi];
          var swapNow = function () {
            zoomImg.classList.remove('rv-zoom-anim');
            zRender();
            zoomImg.src = entry.src;
            zoomImg.alt = entry.alt;
          };
          if (zSwitchTimer) { clearTimeout(zSwitchTimer); zSwitchTimer = null; }
          if (!zoomModal.hidden && zoomImg.getAttribute('src')) {
            /* Fade the old photo out, swap, then the load handler fades the new one in. */
            zoomImg.classList.add('is-switching');
            zSwitchTimer = setTimeout(function () { zSwitchTimer = null; swapNow(); }, 160);
          } else {
            swapNow();
          }
          if (zoomList.length > 1) { var pre = new Image(); pre.src = zoomList[(zi + 1) % zoomList.length].src; }
        };
        var zOpen = function (idx) {
          if (zCloseTimer) { clearTimeout(zCloseTimer); zCloseTimer = null; }
          zShow(idx);
          zoomModal.hidden = false;
          document.documentElement.classList.add('rv-zoom-lock');
          if (zoomCapsule) zoomCapsule.hidden = zoomList.length < 2;
          /* Fade the canvas in while the photo settles from 96% to full size.
             The reflow read makes the opacity transition start from 0. */
          zoomImg.style.transform = 'translate(0px, 0px) scale(0.96)';
          void zoomModal.offsetWidth;
          zoomModal.classList.add('is-open');
          zoomImg.classList.add('rv-zoom-anim');
          setTimeout(function () { zRender(); }, 20);
          setTimeout(function () { zoomImg.classList.remove('rv-zoom-anim'); }, 300);
          var cb = zoomModal.querySelector('[data-rv-zoom-close]');
          if (cb) cb.focus({ preventScroll: true });
        };
        var zClose = function () {
          zoomModal.classList.remove('is-open');
          document.documentElement.classList.remove('rv-zoom-lock');
          if (zCloseTimer) clearTimeout(zCloseTimer);
          zCloseTimer = setTimeout(function () {
            zCloseTimer = null;
            zoomModal.hidden = true;
            zoomImg.removeAttribute('src');
            zoomImg.classList.remove('is-switching');
          }, 260);
          if (zoomOpenBtn) zoomOpenBtn.focus({ preventScroll: true });
        };

        zoomImg.addEventListener('load', function () { zoomImg.classList.remove('is-switching'); zMeasure(); zClamp(); zRender(); });
        window.addEventListener('resize', function () {
          if (!zoomModal.hidden) { zMeasure(); zClamp(); zRender(); }
        });

        zoomModal.addEventListener('pointerdown', function (e) {
          if (e.target.closest('[data-rv-zoom-close],[data-rv-zoom-capsule]')) return;
          e.preventDefault();
          try { zoomModal.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
          if (!zPointers.length) { zMoved = false; zDownTarget = e.target; }
          zPointers.push({ id: e.pointerId, x: e.clientX, y: e.clientY });
          if (zPointers.length === 2) {
            zPinch = { d: Math.hypot(zPointers[0].x - zPointers[1].x, zPointers[0].y - zPointers[1].y), s: zs };
            zPan = null;
          } else if (zPointers.length === 1) {
            zPan = { x: e.clientX, y: e.clientY };
          }
        });
        zoomModal.addEventListener('pointermove', function (e) {
          var p = null, k;
          for (k = 0; k < zPointers.length; k++) if (zPointers[k].id === e.pointerId) p = zPointers[k];
          if (!p) return;
          p.x = e.clientX; p.y = e.clientY;
          if (zPinch && zPointers.length >= 2) {
            var d = Math.hypot(zPointers[0].x - zPointers[1].x, zPointers[0].y - zPointers[1].y);
            if (Math.abs(d - zPinch.d) > 2) zMoved = true;
            if (zPinch.d > 0) zZoomAt((zPointers[0].x + zPointers[1].x) / 2, (zPointers[0].y + zPointers[1].y) / 2, zPinch.s * (d / zPinch.d), false);
          } else if (zPan && zPointers.length === 1) {
            var dx = e.clientX - zPan.x, dy = e.clientY - zPan.y;
            if (Math.abs(dx) > 4 || Math.abs(dy) > 4) zMoved = true;
            if (zs > 1) {
              ztx += dx; zty += dy;
              zPan.x = e.clientX; zPan.y = e.clientY;
              zClamp(); zRender();
            }
          }
        });
        var zEndPointer = function (e) {
          var k;
          for (k = zPointers.length - 1; k >= 0; k--) if (zPointers[k].id === e.pointerId) zPointers.splice(k, 1);
          if (zPointers.length < 2) zPinch = null;
          if (zPointers.length === 1) { zPan = { x: zPointers[0].x, y: zPointers[0].y }; return; }
          if (zPointers.length) return;
          zPan = null;
          /* Touch taps: canceled pointerdown suppresses click, so backdrop
             close and double-tap zoom are resolved here instead. */
          if (!zMoved && e.pointerType !== 'mouse') {
            if (zDownTarget === zoomModal) { zClose(); return; }
            var now = Date.now();
            if (zLastTap && now - zLastTap.t < 350 && Math.hypot(e.clientX - zLastTap.x, e.clientY - zLastTap.y) < 40) {
              zLastTap = null;
              zToggle(e.clientX, e.clientY);
            } else {
              zLastTap = { t: now, x: e.clientX, y: e.clientY };
            }
          }
        };
        zoomModal.addEventListener('pointerup', zEndPointer);
        zoomModal.addEventListener('pointercancel', zEndPointer);

        zoomModal.addEventListener('click', function (e) {
          if (e.target.closest('[data-rv-zoom-close]')) { zClose(); return; }
          if (e.target.closest('[data-rv-zoom-prev]')) { zShow(zi - 1); return; }
          if (e.target.closest('[data-rv-zoom-next]')) { zShow(zi + 1); return; }
          if (e.target === zoomModal && !zMoved) zClose();
        });
        zoomModal.addEventListener('dblclick', function (e) { e.preventDefault(); zToggle(e.clientX, e.clientY); });
        zoomModal.addEventListener('wheel', function (e) {
          e.preventDefault();
          zZoomAt(e.clientX, e.clientY, zs * Math.exp(-e.deltaY * 0.0022), false);
        }, { passive: false });
        document.addEventListener('keydown', function (e) {
          if (zoomModal.hidden) return;
          if (e.key === 'Escape') zClose();
          else if (e.key === 'ArrowLeft' && zoomList.length > 1) zShow(zi - 1);
          else if (e.key === 'ArrowRight' && zoomList.length > 1) zShow(zi + 1);
        });

        /* Gallery-side triggers: a clean tap on an image slide (not a drag,
           not a control) or the magnifier button. */
        var zTapStart = null;
        gallery.addEventListener('pointerdown', function (e) { zTapStart = { x: e.clientX, y: e.clientY }; }, true);
        gallery.addEventListener('click', function (e) {
          if (e.target.closest('[data-rv-gallery-prev],[data-rv-gallery-next],[data-rv-gallery-dot],[data-rv-zoom-open],.rv-video-play')) return;
          var slide = e.target.closest('.rv-gallery__slide');
          if (!slide || !slide.hasAttribute('data-rv-zoom')) return;
          if (zTapStart && Math.hypot(e.clientX - zTapStart.x, e.clientY - zTapStart.y) > 8) return;
          var src = slide.getAttribute('data-rv-zoom');
          for (var k = 0; k < zoomList.length; k++) {
            if (zoomList[k].src === src) { zOpen(k); break; }
          }
        });
        if (zoomOpenBtn) {
          zoomOpenBtn.addEventListener('click', function () {
            var idx = slideZoomIndex[cur()];
            zOpen(idx > -1 ? idx : 0);
          });
        }
      }
    }

    apply();
  }

  /* ---------------- Testimonials ---------------- */
  function initReviews(section) {
    var trackWrap = section.querySelector('.rv-review-slider');
    if (trackWrap) {
      var track = trackWrap.querySelector('.rv-review-track');
      trackWrap.querySelectorAll('[data-rv-reviews-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-rv-reviews-dir'), 10);
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    }
    var showMore = section.querySelector('[data-rv-show-more]');
    if (showMore) {
      showMore.addEventListener('click', function () {
        section.querySelectorAll('.rv-review-stack .rv-review-card.is-hidden').forEach(function (c) {
          c.classList.remove('is-hidden');
        });
        showMore.remove();
      });
    }
  }

  /* ---------------- Reviews page (filter + sort + load more) ---------------- */
  /* The section hands over every loaded review as JSON and server renders only
     the first screenful of cards. Everything after that is built here, so the
     DOM holds the reviews on screen rather than one article per review that
     exists. Keep this markup in step with snippets/riva-review-card.liquid and
     these keys in step with snippets/riva-review-json.liquid. */
  var RV_MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function rvEsc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Mirrors snippets/riva-date.liquid on the server rendered cards. Month names
  // and word order come from the section's data attributes (the visitor's
  // locale) rather than toLocaleDateString, so a card rendered here reads
  // identically to one rendered by Liquid.
  function rvLongDate(iso, months, format) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    if (!m) return '';
    return (format || '%d %m %y')
      .replace('%d', parseInt(m[3], 10))
      .replace('%m', (months || RV_MONTHS)[parseInt(m[2], 10) - 1])
      .replace('%y', m[1]);
  }

  function initReviewsPage(section) {
    var grid = section.querySelector('[data-rv-review-grid]');
    var dataEl = section.querySelector('[data-rv-review-data]');
    if (!grid || !dataEl) return;

    var reviews;
    try { reviews = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(reviews) || !reviews.length) return;

    // The reviews past the first screenful ship as markup for crawlers and are
    // dropped here, because from now on the grid is rendered from the payload.
    var archive = section.querySelector('[data-rv-review-archive]');
    if (archive && archive.parentNode) archive.parentNode.removeChild(archive);

    var monthAttr = section.getAttribute('data-rv-months');
    var months = monthAttr ? monthAttr.split(',') : RV_MONTHS;
    var dateFormat = section.getAttribute('data-rv-date-format');
    var starsLabel = section.getAttribute('data-rv-stars-label') || '%n out of 5 stars';
    var photoAlt = section.getAttribute('data-rv-photo-alt') || '%n review photo';

    var icons = {};
    section.querySelectorAll('[data-rv-icon]').forEach(function (tpl) {
      icons[tpl.getAttribute('data-rv-icon')] = tpl.innerHTML;
    });

    var chips = Array.prototype.slice.call(section.querySelectorAll('[data-rv-review-filter]'));
    var sortSel = section.querySelector('[data-rv-review-sort]');
    var moreBtn = section.querySelector('[data-rv-review-more]');
    var emptyEl = section.querySelector('[data-rv-review-empty]');
    var step = parseInt(grid.getAttribute('data-rv-step'), 10) || 9;
    var shown = step;
    var filter = 'all';
    var sort = 'featured';

    function card(r) {
      var stars = new Array((r.s || 0) + 1).join(icons.star || '');
      var html = '<article class="rv-revcard">';
      if (r.i) {
        html += '<div class="rv-revcard__photo"><img src="' + rvEsc(r.i) + '"' +
          (r.w ? ' srcset="' + rvEsc(r.w) + '"' : '') +
          ' sizes="(max-width: 760px) 100vw, 33vw" loading="lazy" alt="' +
          rvEsc(photoAlt.replace('%n', r.n)) + '"></div>';
      }
      html += '<div class="rv-revcard__body"><div class="rv-revcard__top">' +
        '<span class="rv-stars rv-stars--sm" role="img" aria-label="' +
        rvEsc(starsLabel.replace('%n', r.s)) + '">' + stars + '</span>';
      if (r.d) {
        html += '<time class="rv-revcard__date" datetime="' + rvEsc(r.d) + '">' +
          rvEsc(rvLongDate(r.d, months, dateFormat)) + '</time>';
      }
      html += '</div>';
      if (r.t) html += '<h3 class="rv-revcard__title">' + rvEsc(r.t) + '</h3>';
      html += '<p class="rv-revcard__quote">' + rvEsc(r.q) + '</p>' +
        '<div class="rv-revcard__who"><span class="rv-avatar">' +
        rvEsc((r.n || '').charAt(0)) + '</span><div class="rv-revcard__id">' +
        '<span class="rv-revcard__name">' + rvEsc(r.n) + '</span>';
      if (r.v) {
        html += '<span class="rv-revcard__verified">' + (icons['badge-check'] || '') +
          'Verified Review' + (r.l ? ', ' + rvEsc(r.l) : '') + '</span>';
      } else if (r.l) {
        html += '<span class="rv-revcard__verified">' + rvEsc(r.l) + '</span>';
      }
      html += '</div></div>';
      if (r.p && r.u) {
        html += '<a class="rv-revcard__product" href="' + rvEsc(r.u) + '">' +
          (icons.tag || '') + rvEsc(r.p) + '</a>';
      }
      return html + '</div></article>';
    }

    function matches(r) {
      if (filter === 'all') return true;
      if (filter === 'photo') return !!r.i;
      return String(r.s) === filter;
    }

    function ordered() {
      var list = reviews.filter(matches);
      if (sort === 'recent') {
        list.sort(function (a, b) { return (b.d || '').localeCompare(a.d || ''); });
      } else if (sort === 'highest') {
        list.sort(function (a, b) { return b.s - a.s; });
      } else if (sort === 'lowest') {
        list.sort(function (a, b) { return a.s - b.s; });
      }
      return list;
    }

    function render() {
      var list = ordered();
      grid.innerHTML = list.slice(0, shown).map(card).join('');
      if (moreBtn) moreBtn.hidden = list.length <= shown;
      if (emptyEl) emptyEl.hidden = list.length !== 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        filter = chip.getAttribute('data-rv-review-filter');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        shown = step;
        render();
      });
    });

    if (sortSel) {
      sortSel.addEventListener('change', function () {
        sort = sortSel.value;
        shown = step;
        render();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        shown += step;
        render();
      });
    }

    render();
  }

  /* ---------------- Related products rail ---------------- */
  function initRelatedRail(section) {
    var slider = section.querySelector('.rv-related__slider');
    if (!slider) return;
    var track = slider.querySelector('.rv-related__track');
    var prev = slider.querySelector('[data-rv-related-dir="-1"]');
    var next = slider.querySelector('[data-rv-related-dir="1"]');

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1) { slider.classList.add('is-static'); return; }
      slider.classList.remove('is-static');
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
    }

    slider.querySelectorAll('[data-rv-related-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-rv-related-dir'), 10);
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------------- Buy box ---------------- */
  function initBuyBox(box) {
    var colorCards = box.querySelectorAll('.rv-color-card');
    var addonCards = box.querySelectorAll('.rv-addon-card');
    var totalEl = box.querySelector('[data-rv-atc-total]');
    var hint = box.querySelector('[data-rv-select-hint]');
    var atcBtn = box.querySelector('[data-rv-atc]');
    var priceNow = box.querySelector('[data-rv-price-now]');
    var priceWas = box.querySelector('[data-rv-price-was]');
    var priceSave = box.querySelector('[data-rv-price-save]');
    var variantName = box.querySelector('[data-rv-variant-name]');
    var lowStock = box.querySelector('[data-rv-low-stock]');
    var saveLabel = box.getAttribute('data-rv-save-label') || 'Save [amount]';

    function selectedCard() { return box.querySelector('.rv-color-card.is-active'); }

    /* The headline price tracks the selected colour only; add-ons belong to the ATC total. */
    function updateUnitPrice() {
      var selected = selectedCard();
      if (!priceNow || !selected) return;
      var price = parseInt(selected.getAttribute('data-price'), 10);
      if (isNaN(price)) return;
      var compare = parseInt(selected.getAttribute('data-compare-at'), 10);
      var discounted = !isNaN(compare) && compare > price;
      priceNow.innerHTML = formatMoney(price);
      if (priceWas) {
        priceWas.innerHTML = discounted ? formatMoney(compare) : '';
        priceWas.hidden = !discounted;
      }
      if (priceSave) {
        priceSave.innerHTML = discounted ? saveLabel.replace('[amount]', formatMoney(compare - price)) : '';
        priceSave.hidden = !discounted;
      }
    }

    function update() {
      updateUnitPrice();
      var total = 0;
      var selected = selectedCard();
      if (selected) total += parseInt(selected.getAttribute('data-price'), 10);
      /* A bundle price (Tracker Card 19.00 with a wallet) only applies when a wallet colour is chosen. */
      addonCards.forEach(function (card) {
        if (!card.classList.contains('is-checked')) return;
        var bundle = selected && card.getAttribute('data-bundle-price');
        total += parseInt(bundle || card.getAttribute('data-price'), 10);
      });
      if (totalEl) totalEl.innerHTML = formatMoney(total);
      var stickyTotal = document.querySelector('[data-rv-sticky-total]');
      if (stickyTotal) stickyTotal.innerHTML = formatMoney(total);
      if (hint) hint.style.display = selected ? 'none' : '';
      if (atcBtn) atcBtn.disabled = !selected && addonCards.length === 0;
    }

    colorCards.forEach(function (card) {
      card.addEventListener('click', function () {
        colorCards.forEach(function (other) {
          other.classList.toggle('is-active', other === card);
          other.setAttribute('aria-pressed', other === card ? 'true' : 'false');
        });
        if (variantName) variantName.textContent = card.getAttribute('data-title') || '';
        if (lowStock) lowStock.hidden = !card.hasAttribute('data-low-stock');
        /* Show the chosen colour's photo in the gallery */
        var mediaIndex = card.getAttribute('data-media-index');
        if (mediaIndex !== null) {
          var go = document.querySelector('.rv-gallery [data-rv-gallery-dot="' + mediaIndex + '"]');
          if (go) go.click();
        }
        update();
      });
    });

    /* Only the switch toggles an add-on; the card body is not a click target. */
    addonCards.forEach(function (card) {
      var toggle = card.querySelector('[data-rv-addon-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          card.classList.toggle('is-checked');
          toggle.setAttribute('aria-checked', card.classList.contains('is-checked') ? 'true' : 'false');
          update();
        });
      }
      var learn = card.querySelector('[data-rv-addon-learn]');
      if (learn) {
        learn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openAddonDrawer(card.getAttribute('data-addon-id'));
        });
      }
    });

    var moreBtn = box.querySelector('[data-rv-addon-more]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        box.querySelectorAll('[data-rv-addon-extra]').forEach(function (c) { c.hidden = false; });
        moreBtn.remove();
      });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var items = [];
        var selected = selectedCard();
        if (selected) items.push({ id: parseInt(selected.getAttribute('data-variant-id'), 10), quantity: 1 });
        addonCards.forEach(function (card) {
          if (card.classList.contains('is-checked')) {
            items.push({ id: parseInt(card.getAttribute('data-variant-id'), 10), quantity: 1 });
          }
        });
        if (!items.length) return;
        cart.add(items);
      });
    }
    update();

    /* Open the gallery on the selected colour's photo (e.g. a ?variant= link) */
    var startCard = selectedCard();
    var startIndex = startCard ? startCard.getAttribute('data-media-index') : null;
    if (startIndex !== null && startIndex !== '0') {
      requestAnimationFrame(function () {
        var go = document.querySelector('.rv-gallery [data-rv-gallery-dot="' + startIndex + '"]');
        if (go) go.click();
      });
    }
  }

  /* ---------------- Add-on learn-more drawer ---------------- */
  function openAddonDrawer(addonId) {
    var drawer = document.querySelector('.rv-addon-drawer[data-addon-drawer-id="' + addonId + '"]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
  }
  function initAddonDrawers(root) {
    (root || document).querySelectorAll('.rv-addon-drawer').forEach(function (drawer) {
      var slides = drawer.querySelectorAll('.rv-slide');
      var counter = drawer.querySelector('[data-rv-addon-count]');
      var sel = 0;
      function apply() {
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === sel); });
        if (counter) counter.textContent = (sel + 1) + ' / ' + slides.length;
      }
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-rv-addon-close], .rv-drawer__overlay')) {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          return;
        }
        if (e.target.closest('[data-rv-addon-prev]')) { sel = (sel - 1 + slides.length) % slides.length; apply(); }
        if (e.target.closest('[data-rv-addon-next]')) { sel = (sel + 1) % slides.length; apply(); }
      });
      apply();
    });
  }

  /* ---------------- Sticky ATC ---------------- */
  function initStickyAtc() {
    var bar = document.querySelector('.rv-sticky-atc');
    var anchor = document.querySelector('[data-rv-atc]');
    if (!bar || !anchor) return;
    var footer = document.querySelector('.rv-footer');
    var update = function () {
      var pastAtc = anchor.getBoundingClientRect().bottom < 0;
      var footerInView = footer && footer.getBoundingClientRect().top < window.innerHeight;
      bar.classList.toggle('is-visible', pastAtc && !footerInView);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    var btn = bar.querySelector('[data-rv-sticky-add]');
    if (btn) {
      btn.addEventListener('click', function () { anchor.click(); });
    }
  }

  /* ---------------- Footer signup ---------------- */
  /* Shopify's spam protection only starts loading hCaptcha when the shopper focuses
     the form, and it cancels any submit that lands before hCaptcha has bound
     (data-hcaptcha-bound), so a quick first click on Subscribe did nothing. Wait
     for the binding and send the submit again; from then on hCaptcha handles it. */
  /* The footer also subscribes the address to the Klaviyo list behind the signup popups,
     so the Klaviyo welcome flow sends the code. The profile fields mirror the popups'
     hidden fields; the US and AU markets have their own codes. keepalive lets the request
     finish while the form post navigates away. */
  var KLAVIYO_OFFERS = {
    'united-states': { riva_currency: 'USD', riva_offer: '$5', riva_code: 'WELCOME5US', riva_min: '$70' },
    'australia': { riva_currency: 'AUD', riva_offer: 'A$5', riva_code: 'WELCOME5AU', riva_min: 'A$95' }
  };

  function subscribeToKlaviyo(form) {
    var cfg = form.querySelector('[data-rv-klaviyo]');
    var input = form.querySelector('input[type="email"]');
    if (!cfg || !input || !input.value || !input.checkValidity()) return;
    var lang = cfg.getAttribute('data-lang');
    var props = { riva_language: (lang === 'de' || lang === 'fr') ? lang : 'en', riva_currency: 'EUR' };
    var offer = KLAVIYO_OFFERS[cfg.getAttribute('data-market')];
    if (offer) Object.keys(offer).forEach(function (k) { props[k] = offer[k]; });
    try {
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + cfg.getAttribute('data-company'), {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Footer signup',
          profile: { data: { type: 'profile', attributes: { email: input.value.trim(), properties: props } } }
        }, relationships: { list: { data: { type: 'list', id: cfg.getAttribute('data-list') } } } } })
      }).catch(function () {});
    } catch (e) { /* the Shopify signup still goes through */ }
  }

  function initFooterSignup() {
    var form = document.getElementById('RivaFooterSignup');
    if (!form || form.dataset.rvSignupInit) return;
    form.dataset.rvSignupInit = '1';
    form.addEventListener('submit', function () {
      if (!form.dataset.rvKlaviyoSent) {
        form.dataset.rvKlaviyoSent = '1';
        subscribeToKlaviyo(form);
      }
      if (form.dataset.hcaptchaBound || form.dataset.rvRetrying) return;
      form.dataset.rvRetrying = '1';
      var tries = 0;
      var timer = window.setInterval(function () {
        tries += 1;
        if (form.dataset.hcaptchaBound) {
          window.clearInterval(timer);
          delete form.dataset.rvRetrying;
          if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type="submit"]').click();
        } else if (tries > 100) {
          window.clearInterval(timer);
          delete form.dataset.rvRetrying;
        }
      }, 100);
    });
  }

  /* ---------------- Email capture popup ---------------- */
  function initEmailPopup() {
    var root = document.querySelector('[data-rv-email-popup]');
    if (!root || root.getAttribute('data-rv-bound') === '1') return;
    root.setAttribute('data-rv-bound', '1');

    var SEEN = 'riva_popup_seen';
    var PENDING = 'riva_popup_pending';
    var panel = root.querySelector('.rv-popup__panel');
    var success = root.querySelector('[data-rv-popup-success]');
    var form = root.querySelector('form');
    var days = parseInt(root.getAttribute('data-days'), 10) || 30;
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 30;
    var scrollPct = parseInt(root.getAttribute('data-scroll'), 10) || 40;
    var isOpen = false;
    var permanent = false;
    var lastFocus = null;
    var consentPoll = null;

    /* Private browsing and blocked site data both throw on access, so every
       read and write is guarded and an unreadable store just means "not seen". */
    function put(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function drop(k) { try { localStorage.removeItem(k); } catch (e) {} }

    function suppressed() {
      var until = get(SEEN);
      if (!until) return false;
      if (until === 'forever') return true;
      return Date.now() < parseInt(until, 10);
    }

    /* The cookie banner owns the bottom of the screen until it is answered, and
       it outranks us by nine orders of z-index, so on a short phone it covers
       the submit button entirely. Consentmo renders inside a shadow root, so a
       light-DOM query never sees it: reach through shadowRoot first. */
    function consentUp() {
      var el = null;
      try {
        var host = document.querySelector('csm-cookie-consent');
        if (host && host.shadowRoot) el = host.shadowRoot.querySelector('.csm-cmp-bar');
        if (!el) el = document.querySelector('[id*="consentmo" i], [class*="consentmo" i], .gdpr-cookie-consent');
      } catch (e) {
        return false;
      }
      if (!el) return false;
      var box = el.getBoundingClientRect();
      return box.height > 0 && box.width > 0 && getComputedStyle(el).visibility !== 'hidden';
    }

    /* Wait the banner out rather than counting attempts. The old version gave up
       after 20 tries and, because the counter was shared, a later scroll or timer
       could never open the popup either. */
    function waitForConsent() {
      if (consentPoll) return;
      consentPoll = window.setInterval(function () {
        if (isOpen) { window.clearInterval(consentPoll); consentPoll = null; return; }
        if (!consentUp()) {
          window.clearInterval(consentPoll);
          consentPoll = null;
          open(false);
        }
      }, 500);
    }

    function trap(e) {
      if (e.key !== 'Tab' || !panel) return;
      var items = panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(false); return; }
      trap(e);
    }

    function open(force) {
      if (isOpen) return;
      if (!force && suppressed()) return;
      if (!force && consentUp()) { waitForConsent(); return; }
      isOpen = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      root.removeAttribute('aria-hidden');
      /* Force a reflow so the transition has a start state, then reveal in the
         same tick. requestAnimationFrame would be throttled in a background
         tab, which locks the scroll while leaving the panel at opacity 0. */
      void root.offsetWidth;
      root.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var field = root.querySelector('input[type="email"]') || root.querySelector('.rv-popup__close');
      if (field) field.focus();
      document.addEventListener('keydown', onKey);
    }

    function close(forever) {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      put(SEEN, (forever || permanent) ? 'forever' : String(Date.now() + days * 86400000));
      document.removeEventListener('keydown', onKey);
      window.setTimeout(function () { if (!isOpen) root.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.querySelectorAll('[data-rv-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () { close(false); });
    });

    /* Shopify posts the customer form as a full page load and returns with
       customer_posted=true. The newsletter section shares that flag, so pair it
       with our own marker to tell an actual popup signup from a footer one. */
    if (success) {
      if (get(PENDING)) {
        drop(PENDING);
        permanent = true;
        put(SEEN, 'forever');
        open(true);
      }
      return;
    }

    if (suppressed()) return;

    if (form) {
      form.addEventListener('submit', function () { put(PENDING, '1'); });
    }

    window.setTimeout(function () { open(false); }, delay * 1000);

    /* Three independent triggers, whichever fires first. Exit intent is the
       only one that needs a cursor able to leave the viewport, so it alone is
       pointer-gated. Scroll depth and the dwell timer run everywhere. */
    if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (e.clientY <= 0 && !e.relatedTarget) open(false);
      });
    }

    var onScroll = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && (window.scrollY / h) * 100 >= scrollPct) {
        window.removeEventListener('scroll', onScroll);
        open(false);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Hero video ---------------- */
  function initHeroVideo(video) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* ---------------- Welcome offer in the shopper's currency ---------------- */
  /* Liquid renders the WELCOME10 amounts in EUR; Shopify converts them at checkout
     with Shopify.currency.rate, so show the same converted amounts here. */
  function initWelcomeCurrency(root) {
    var currency = window.Shopify && window.Shopify.currency;
    if (!currency || currency.active === 'EUR') return;
    var rate = parseFloat(currency.rate);
    if (!rate) return;
    root.querySelectorAll('[data-rv-welcome-text]').forEach(function (el) {
      var amount = Math.round(parseInt(el.getAttribute('data-amount'), 10) * rate);
      var minimum = Math.round(parseInt(el.getAttribute('data-minimum'), 10) * rate);
      el.innerHTML = el.getAttribute('data-template')
        .split('[[amount]]').join(formatMoney(amount))
        .split('[[minimum]]').join(formatMoney(minimum));
    });
  }

  function initComponents(root) {
    initWelcomeCurrency(root);
    root.querySelectorAll('[data-rv-hero-video]').forEach(initHeroVideo);
    initLocalePickers(root);
    root.querySelectorAll('.rv-gallery').forEach(initGallery);
    root.querySelectorAll('[data-rv-reviews]').forEach(initReviews);
    root.querySelectorAll('[data-rv-reviews-page]').forEach(initReviewsPage);
    root.querySelectorAll('[data-rv-related]').forEach(initRelatedRail);
    root.querySelectorAll('.rv-buybox').forEach(initBuyBox);
    initAddonDrawers(root);
    initStickyAtc();
    initDeadlines(root);
    initEmailPopup();
    initFooterSignup();
    root.querySelectorAll('[data-rv-open-cart]').forEach(function (el) {
      if (el.closest('.rv-header-stack')) return;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        cart.open();
      });
    });
  }

  onReady(function () {
    initHeader();
    initAnnouncement();
    cart.init();
    initComponents(document);
    initGeoCountry();
  });

  /* Theme editor: re-bind components when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    initComponents(e.target);
  });
})();
